// import tr from './tr';
import en from './en';
import de from './de';
import nl from './nl';

export const dictionaryList = {
  de,
  en,
  nl
};

export const languageOptions = [
  { id: 'de', text: 'Deutsch' },
  { id: 'en', text: 'English'},
  { id: 'nl', text: 'Dutch'}

];